var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1793 4.069C11.7414 2.64367 13.7586 2.64367 14.3207 4.069L16.0628 8.48598C16.2344 8.92114 16.5789 9.2656 17.014 9.43723L21.431 11.1793C22.8563 11.7414 22.8563 13.7586 21.431 14.3207L17.014 16.0628C16.5789 16.2344 16.2344 16.5789 16.0628 17.014L14.3207 21.431C13.7586 22.8563 11.7414 22.8563 11.1793 21.431L9.43723 17.014C9.2656 16.5789 8.92114 16.2344 8.48598 16.0628L4.069 14.3207C2.64367 13.7586 2.64367 11.7414 4.069 11.1793L8.48598 9.43723C8.92114 9.2656 9.2656 8.92114 9.43723 8.48598L11.1793 4.069Z",
    fill: "url(#paint0_linear_482_41157)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3848 20.0875C25.6938 19.3042 26.8023 19.3042 27.1113 20.0875L28.4623 23.513C28.5566 23.7522 28.7459 23.9415 28.985 24.0358L32.4106 25.3868C33.1939 25.6957 33.1939 26.8043 32.4106 27.1132L28.985 28.4642C28.7459 28.5585 28.5566 28.7478 28.4623 28.987L27.1113 32.4125C26.8023 33.1958 25.6938 33.1958 25.3848 32.4125L24.0338 28.987C23.9395 28.7478 23.7502 28.5585 23.5111 28.4642L20.0855 27.1132C19.3022 26.8043 19.3022 25.6957 20.0855 25.3868L23.5111 24.0358C23.7502 23.9415 23.9395 23.7522 24.0338 23.513L25.3848 20.0875Z",
    fill: "url(#paint1_linear_482_41157)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_482_41157",
    x1: 4.76719,
    y1: -0.767046,
    x2: 30.195,
    y2: 13.5835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCF91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_482_41157",
    x1: 20.7215,
    y1: 16.892,
    x2: 38.3253,
    y2: 26.8271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCF91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarsIcon);
export default __webpack_public_path__ + "static/media/StarsIcon.933df0a66220fa46933d97a95838ef05.svg";
export { ForwardRef as ReactComponent };